'use client';

import styled from 'styled-components';

export const StyledForm = styled.form`
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
`;

export const StyledFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-2n);

  @media only screen and (width >= 600px) {
    button[type='submit'] {
      align-self: flex-start;
    }
  }
`;

export const StyledFormRow = styled.div`
  display: grid;
  gap: var(--size-1);
  grid-template-columns: 1fr 1fr;

  @media only screen and (width <= 600px) {
    grid-template-columns: 1fr;
    gap: var(--size-2n);
    flex-direction: column;
  }
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  gap: var(--size-1);
  width: 80%;
  align-items: center; /* Center the items vertically */
`;

export const StyledLabel = styled.label`
  flex: 1; /* Take up equal space within the flex container */
  margin-right: var(--size-1);
  text-align: right; /* Align text to the right */
`;

export const StyledSelect = styled.select`
  flex: 1; /* Take up equal space within the flex container */
  padding: var(--size-1);
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
`;
